"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _table = _interopRequireDefault(require("../../../../core/table"));
var _gbp = _interopRequireDefault(require("gbp"));
var _payment = _interopRequireDefault(require("./payment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// the styled components are purely to improve the layout of the printed version of the start list
// Tr shrinks all the table rows. Tbody should stop breaks within each group but does not always do so
// successfully (depends on browser).
const Tr = _styledComponents.default.tr`
  @media print {
    font-size: 0.6em;
    line-height: 0.6em;
  }
`;
const H2 = _styledComponents.default.h2`
  @media print {
    font-size: 1em;
    line-height: 1em;
    margin-bottom: 0em;
    margin-top: 0.1em;
  }
  margin-top: 0.5em;
`;
const Tbody = _styledComponents.default.tbody`
  @media print {
    page-break-inside: avoid;
  }
`;
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "You must be logged in as a Competition Administrator to see this page");
var _ref2 = /*#__PURE__*/_react.default.createElement(H2, null, "Payments and Refunds by Entries");
var _ref3 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement(Tr, null, /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: 2
}, "Race"), /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: 2
}, "Bib"), /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: 2
}, "Name"), /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: 2
}), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: 3,
  className: "cell-border-left text-xs-center"
}, "Received"), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: 3,
  className: "cell-border-left text-xs-center"
}, "Refunded"), /*#__PURE__*/_react.default.createElement("th", {
  rowSpan: 2,
  className: "cell-border-left text-xs-right"
}, "Balance")), /*#__PURE__*/_react.default.createElement(Tr, null, /*#__PURE__*/_react.default.createElement("th", {
  className: "cell-border-left"
}, "Date"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Amount"), /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", {
  className: "cell-border-left"
}, "Date"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Amount"), /*#__PURE__*/_react.default.createElement("th", null)));
var _ref4 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "BALANCE");
class PaymentsByEntries extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_getTotalRefundsForPayment", refunds => {
      let refunded = 0;
      for (const refund of refunds) {
        refunded += refund.refundedByClub;
      }
      return refunded;
    });
  }
  render() {
    const competition = this.props.competition;

    // Calculate total payments and refunds
    let totalExpectedForClub = 0;
    let totalRefundedByClub = 0;
    let numberOfRefunds = 0;
    let numberOfPayments = 0;
    if (this.props.loaded) {
      numberOfPayments = Object.keys(competition.payments).length;
      for (const payment of competition.payments) {
        totalExpectedForClub += payment.expectedForClub;
        numberOfRefunds += Object.keys(payment.refunds).length;
        totalRefundedByClub += this._getTotalRefundsForPayment(payment.refunds);
      }
    }

    // sort payments based on the first entry covered by the payment
    const sortedPayments = this.props.competition.payments.slice().sort((a, b) => {
      if (a.entries[0].competitionDivision.divLevel > b.entries[0].competitionDivision.divLevel) {
        return 1;
      } else if (a.entries[0].competitionDivision.divLevel < b.entries[0].competitionDivision.divLevel) {
        return -1;
      } else if (a.entries[0].race.event.sortOrder > b.entries[0].race.event.sortOrder) {
        return 1;
      } else if (a.entries[0].race.event.sortOrder < b.entries[0].race.event.sortOrder) {
        return -1;
      } else if (a.entries[0].adjustedBibNumber > b.entries[0].adjustedBibNumber) {
        return -1;
      } else if (a.entries[0].adjustedBibNumber < b.entries[0].adjustedBibNumber) {
        return 1;
      } else return 0;
    });
    if (!competition.isAdministratedByUser) return _ref;
    return /*#__PURE__*/_react.default.createElement("div", null, _ref2, /*#__PURE__*/_react.default.createElement(_table.default, null, _ref3, sortedPayments.map(payment => /*#__PURE__*/_react.default.createElement(_payment.default, {
      key: payment.id,
      payment: payment
    })), /*#__PURE__*/_react.default.createElement("tfoot", {
      className: "hidden-print"
    }, /*#__PURE__*/_react.default.createElement(Tr, null, /*#__PURE__*/_react.default.createElement("th", {
      colSpan: 5,
      className: "text-xs-right"
    }, numberOfPayments + ' Payments Totalling'), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(totalExpectedForClub)), /*#__PURE__*/_react.default.createElement("th", {
      colSpan: 2,
      className: "text-xs-right"
    }, numberOfRefunds + ' Refunds Totalling'), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(totalRefundedByClub)), _ref4, /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(totalExpectedForClub - totalRefundedByClub))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref5 = {
  isAdministratedByUser: true,
  payments: _mergeBqlQueries({
    id: true,
    expectedForClub: true,
    refunds: {
      id: true,
      refundedByClub: true
    },
    entries: {
      id: true,
      adjustedBibNumber: true,
      entryStatus: {
        description: true
      },
      competitionDivision: {
        description: true,
        divLevel: true
      },
      race: {
        event: {
          description: true,
          sortOrder: true
        },
        competitionDay: {
          dayDate: true
        }
      }
    }
  }, _payment.default.partialQueries.Payment)
};
var _default = exports.default = (0, _reactBicycle.connect)(PaymentsByEntries, props => ({
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref5
}));